import * as React from "react";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../Urls";
import { Contents } from "../../../Resoures/Contents";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { UpdateLifetimeAllowanceStore } from "./Store/Variable";
import { AccountLifetimeAllowanceStore } from "./Store/Variable";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { updateLifetimeAllowanceSteppersMap } from "./Resource/Content";
import { UpdateLifetimeAllowanceAction } from "./Actions/UpdateLifetimeAllowanceAction";
import { AccountLifetimeAllowanceAction } from "./Actions/AccountLifetimeAllowanceAction";
import { IStepConfig, StepType } from "../../../../Shared/Process/Process/Process";
import { UpdateLifetimeAllowanceDetail } from "./Components/UpdateLifetimeAllowanceDetail";
import { TaxYearHelper } from "../Common/Helpers/TaxYearHelper";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Action } from "../../../Actions/Action";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { AccountRole } from "../../../../../Wrap/Models/Domains/Account/AccountRole";
import { OffPlatformLifeTimeAllowance } from "../../../../../Wrap/Models/Domains/Account/OffPlatformLifeTimeAllowance";
import { PastLumpSumAllowanceUsed } from "../../../../../Wrap/Models/Domains/Drawdown/PastLumpSumAllowanceUsed";
import { PensionAllowanceType } from "../../../../../Wrap/Models/Domains/Drawdown/PensionAllowanceType";
import { AllowanceRecordCategory } from "../../../../../Wrap/Models/Domains/Drawdown/AllowanceRecordCategory";

export class UpdateLifetimeAllowanceWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(AccountLifetimeAllowanceStore, () => this.onAccountLifetimeAllowanceStoreChange());
    }


    private onAccountLifetimeAllowanceStoreChange() {
        if (AccountLifetimeAllowanceStore.getActionType() == ActionType.Success) {
            const data = AccountLifetimeAllowanceStore.getData();
            this.setState((preState) => ({
                isLoading: false,
                extraInfo: {
                    ...preState.extraInfo, onPlatformData: data, offPlatformData: {
                        otherUsedAsAt5April2024Amount: null,
                        otherUsedOnOrAfter6April2024Amount: null,
                        otherLSDBAUsedAsAt5April2024Amount: null,
                        otherLSDBAUsedOnOrAfter6April2024Amount: null,
                        isPartOfUsedSIHBefore75: false,
                        hasTakenIllHealthLumpSum: false
                    }
                },
                data: {
                    ...preState.extraInfo, onPlatformData: data,
                    offPlatformData: {
                        otherUsedAsAt5April2024Amount: data.UsedOffPlatformLumpSumAllowancePre2024,
                        otherUsedOnOrAfter6April2024Amount: data.UsedOffPlatformLumpSumAllowancePost2024,
                        otherLSDBAUsedAsAt5April2024Amount: data.UsedOffPlatformLumpSumDeathBenefitsAllowancePre2024,
                        otherLSDBAUsedOnOrAfter6April2024Amount: data.UsedOffPlatformLumpSumDeathBenefitsAllowancePost2024,
                        isPartOfUsedSIHBefore75: false,
                        hasTakenIllHealthLumpSum: data.HasSevereIllHealthDeclaration
                    }
                },
            }));
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();
        const subAccountHierarchyId = params["hierarchyid"];
        Action.getClientAccount(getQueryParameters()["hierarchyid"], (ClientAccountDetails) =>
            this.setClientAccount(ClientAccountDetails)
        );
        // UpdateLifetimeAllowanceAction.getInstruction(subAccountHierarchyId);
        Action.getAccountRoles(subAccountHierarchyId, (accountRoleDetails) => this.setClientInfo(accountRoleDetails));
        AccountLifetimeAllowanceAction.getInstruction(subAccountHierarchyId);
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: true,
            });
        }
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        const accountRoles = AccountRoleStore.getAccountRoles();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        const instruction=this.buildOffPlatformLifeTimeAllowanceData()

        const account = ClientAccountStore.getActiveClientSubAccounts().find(
            (x) => x.SubAccountType == SubAccountType.Npr || x.SubAccountType == SubAccountType.JuniorSipp
        );
        UpdateLifetimeAllowanceAction.submitInstruction(account.HierarchyId, instruction, () =>
            this.setState({ isSubmitting: false })
        );
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    private buildOffPlatformLifeTimeAllowanceData(): OffPlatformLifeTimeAllowance {
        const { data } = this.state;
        const pastLumpSumAllowancesUsed = [] as PastLumpSumAllowanceUsed[];

        if (data.offPlatformData.otherUsedAsAt5April2024Amount) {
            pastLumpSumAllowancesUsed.push({
                Type: PensionAllowanceType.LumpSum,
                Category: AllowanceRecordCategory.OffPlatformPre2024,
                Amount: {
                    Currency: CurrencyCode.GBP,
                    Amount: data.offPlatformData?.otherUsedAsAt5April2024Amount,
                },
            });
        }

        if (data.offPlatformData.otherUsedOnOrAfter6April2024Amount) {
            pastLumpSumAllowancesUsed.push({
                Type: PensionAllowanceType.LumpSum,
                Category: AllowanceRecordCategory.OffPlatformPost2024,
                Amount: {
                    Currency: CurrencyCode.GBP,
                    Amount:
                    data.offPlatformData?.otherUsedOnOrAfter6April2024Amount,
                },
            });
        }

        if (data.offPlatformData.otherLSDBAUsedAsAt5April2024Amount) {
            pastLumpSumAllowancesUsed.push({
                Type: PensionAllowanceType.LumpSumDeathBenefits,
                Category: AllowanceRecordCategory.OffPlatformPre2024,
                Amount: {
                    Currency: CurrencyCode.GBP,
                    Amount:
                    data.offPlatformData?.otherLSDBAUsedAsAt5April2024Amount,
                },
            });
        }

        if (data.offPlatformData.otherLSDBAUsedOnOrAfter6April2024Amount) {
            pastLumpSumAllowancesUsed.push({
                Type: PensionAllowanceType.LumpSumDeathBenefits,
                Category: AllowanceRecordCategory.OffPlatformPost2024,
                Amount: {
                    Currency: CurrencyCode.GBP,
                    Amount:
                    data.offPlatformData?.otherLSDBAUsedOnOrAfter6April2024Amount,
                },
            });
        }

        return {
            PastLumpSumAllowancesUsed: pastLumpSumAllowancesUsed,
            SeriousIllHealth: data.offPlatformData.hasTakenIllHealthLumpSum
        };
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const { clientInfo, clientAccount } = this.state;
        const len = this.stepperConfig.length;
        return [
            {
                title: updateLifetimeAllowanceSteppersMap.updateLifetimeAllowanceConfirmation,
                url: Urls.get().UpdateLifetimeAllowanceConfirmation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We have successfully received your instruction to update the Lifetime allowance for ${clientInfo?.firstName} ${clientInfo?.lastName} (${clientAccount?.HeadClAccountId})`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }


    setStepperConfig() {
        const steppers: IStepConfig[] = [
            {
                title: updateLifetimeAllowanceSteppersMap.updateLifetimeAllowanceDetail,
                url: Urls.get().UpdateLifetimeAllowanceDetail,
                path: Contents.URLMap.updateLifetimeAllowanceDetail,
                onSubmit: () => this.onSubmit(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <UpdateLifetimeAllowanceDetail {...this.getStepProps(0)} extraInfo={this.state.extraInfo} />,
            },
        ];

        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const { clientAccount, clientInfo } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Update Allowance Details";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${clientInfo?.firstName} ${clientInfo?.lastName}`,
            splitHeaderSub: `${clientAccount?.HeadClAccountId}`,
        };
        return processProps;
    }

    setClientAccount(ClientAccountDetails) {
        const accountName = ClientAccountDetails.AccountName;
        const headAccount = ClientAccountDetails.HeadClAccountId;
        this.setState({
            clientAccount: {
                AccountName: accountName,
                HeadClAccountId: headAccount,
            },
        });
    }

    setClientInfo(accountRoleDetails: AccountRole[]) {
        const firstName: string = accountRoleDetails[0].Customer?.PersonalDetails?.Name?.Given;
        const lastName: string = accountRoleDetails[0].Customer?.PersonalDetails?.Name?.Family;
        this.setState({
            clientInfo: {
                firstName: firstName,
                lastName: lastName,
            },
        });
    }
}
